import Modal from 'components/modal';
import SendReplyMSG from 'components/modal/sendReplyMSG';
import moment from 'jalali-moment';
import React, {useState} from 'react';

interface RegisteredOffersPrepaymentItemProps {
  created_at: string;
  name: string;
  price: number;
  postType: string;
  guid: string;
  profile_type: string;
}
const RregisteredOffersPrepaymentItem = ({
  created_at,
  name,
  price,
  guid,
  postType,
  profile_type,
}: RegisteredOffersPrepaymentItemProps) => {
  const [isSendMSGOpen, setIsSendMSGOpen] = useState<boolean>(false);

  return (
    <>
      <div className="flex w-full items-center justify-between py-3 text-green-1">
        <div className="pr-3 text-gray-6 w-[30%] flex items-center justify-center text-[14px]">
          {name}
        </div>
        <div className="text-gray-6 w-[30%] flex items-center justify-center text-[14px]">
          {moment(created_at).format('jYYYY/jMM/jDD')}
        </div>
        <div className="text-gray-6 w-[30%] flex items-center justify-center text-[14px]">
          {price.toLocaleString()}
        </div>

        <div className=" w-[10%] flex items-center justify-center">
          <button
            className="icon-chat pl-2 text-[20px]"
            onClick={() => setIsSendMSGOpen(prev => !prev)}
          />
        </div>
      </div>
      <Modal isOpen={isSendMSGOpen} setIsOpen={setIsSendMSGOpen}>
        <SendReplyMSG
          post={guid}
          setIsOpen={setIsSendMSGOpen}
          post_type={postType}
          profile_type={profile_type}
        />
      </Modal>
    </>
  );
};

export default RregisteredOffersPrepaymentItem;
